import type { AnyAction } from 'redux';

export const createMatcher = <T = AnyAction>(actionTypes: string[]) => (
  action
): action is T => actionTypes.includes(action.type);
